import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Verificar si el usuario está autenticado
    return this.authService.isAuthenticatedAndValid().pipe(
      map(res => {
        if (res && res.valid) {
          // Si el usuario está autenticado y válido, cerrar sesión y redirigir al login
          this.authService.logout();
          // Redirigir al login con un mensaje indicando que se cerró la sesión
          return this.router.createUrlTree(['/'], { 
            queryParams: { message: 'session_closed_for_landing' } 
          });
        } else {
          // Si no está autenticado, permitir acceso al landing
          return true;
        }
      }),
      catchError(() => {
        // En caso de error, permitir acceso al landing
        return of(true);
      })
    );
  }
}